/**
 * Whether the player asked the browser for less motion.
 * @returns {boolean}
 */
export function prefersReducedMotion() {
  try {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (e) {
    return false;
  }
}

export default prefersReducedMotion;
